"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShowSeasonStencil = exports.showSeasonStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.showSeasonStencilDefinition = {
    view: {
        label: 'Show Season',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'label',
                    'teaser',
                    'description',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                            'geolocation',
                            'show',
                            'season-number',
                            'episode-video-ref',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'content-classification-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.descriptionPropertyDefinition.name]: properties_1.descriptionPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.episodeVideoRefPropertyDefinition.name]: properties_1.episodeVideoRefPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: {
            ...properties_1.featuredMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.labelPropertyDefinition.name]: properties_1.labelPropertyDefinition,
        [properties_1.noMonetizationPropertyDefinition.name]: properties_1.noMonetizationPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.seasonNumberPropertyDefinition.name]: properties_1.seasonNumberPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.showPropertyDefinition.name]: properties_1.showPropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull-racing',
    ],
    name: 'season',
};
const isShowSeasonStencil = (stencil) => {
    return stencil.name === exports.showSeasonStencilDefinition.name;
};
exports.isShowSeasonStencil = isShowSeasonStencil;
//# sourceMappingURL=data:application/json;base64,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